export const itemFilter = field => {
  let res = field;
  if (field === undefined||field === null) {
    res = "";
  }
  return res;
};